import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { KeyService } from 'src/app/shared/services/API/emerges-key/key.service';

@Component({
  selector: 'app-key-delete-modal',
  templateUrl: './key-delete-modal.component.html',
  styleUrls: ['./key-delete-modal.component.css']
})
export class KeyDeleteModalComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, 
  public dialog: MatDialog, 
  public matDialogRef: MatDialogRef<KeyDeleteModalComponent>,
  private keyService: KeyService,
  private alertService: AlertService,) { }
  
  public isLoading:boolean;  

  ngOnInit(): void {
    this.isLoading = false;
  }
  
  close(){
    this.matDialogRef.close({deleteKey: false}); 
  }
  
  clickDelete(){
    
    this.isLoading = true;

    this.keyService.deleteKey(this.data.idKey).subscribe((response)=>{
      
      if(response.isError){
        this.alertService.show('Erro', response.errorDescription, AlertType.error);
        this.isLoading = false;
        return;
      }
      
      this.alertService.show('Sucesso', "Chave excluída com sucesso!", AlertType.success); 
      this.matDialogRef.close({deleteKey: true}); 
    },
    (error)=>{
      console.log(error)
      this.isLoading = false;
      this.alertService.show('Erro inesperado', error, AlertType.error);
    });
  }
  
  clickCancel(){
    this.matDialogRef.close({deleteKey: false}); 
  }

}